export default __webpack_public_path__ + "static/media/dongho-02.844a8258.svg";